export default __webpack_public_path__ + "static/media/rightQuote.cd9decab.svg";